/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from "react";
import { Content, CustomLabel, Text } from "./styles";
import { Col, Row } from "components/Grid";
import { NotesAccordion } from "components";
import { GlobalAuthContext } from "store/context";
import EnquiryCard, { EnquiryCardContainer } from 'components/EnquiryCard'
import { FitinsurAPI } from 'utils';
import MasksHelper from "../../utils/src/masks";

export default function BrokingSummary(props) {
  const {
    idOperation,
    idProduct
  } = props;
  const authContext = useContext(GlobalAuthContext);
  const isClient = authContext.enumProfile === 1 ? true : false;
  const fitinsur = new FitinsurAPI();

  const [persons, setPersons] = useState([])

  const handleGetQuote = async () => {
    fitinsur.setAuthToken(authContext.token);
    await fitinsur.requestGetQuote(idProduct || 34, idOperation, true)
      .then((x) => x.json())
      .then((response) => {
        const masks = new MasksHelper();

        let filteredPersons = response.ret_value.persons.filter(question => (
          (question.idQuestion === 658 ||
            question.idQuestion === 659 ||
            question.idQuestion === 660) && (question.answer || question.idAnswerOption)
        ))

        const filteredRisks = response.ret_value.risks.filter(question => (
          (question.idQuestion === 673 ||
            question.idQuestion === 674 ||
            question.idQuestion === 675 ||
            question.idQuestion === 1236 ||
            question.idQuestion === 1237
          )
          && (question.answer || question.idAnswerOption)
        ))

        filteredPersons = filteredPersons.map(person => {
          if (person.idQuestion === 658) {
            const cnpjMask = masks.getMask('cnpj', authContext.region);
            person.answer = masks.resolveMask(person.answer, cnpjMask);
          }
          return person;
        })

        setPersons([...filteredPersons, ...filteredRisks]);
      }).catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    async function start() {
      try {
        await handleGetQuote();
      } catch (e) {
        console.log(e)
      }
    }
    start();
  }, [])

  return (
    <Content>
      <Row style={{ flexDirection: 'column' }}>
        <EnquiryCardContainer>
          <Col xs={12} md={4} style={{ paddingLeft: 0, marginBottom: 10, paddingRight: '15px' }}>
            <EnquiryCard
              person={{}}
              idQuestion={1}
              field={"COTACAO Nº"}
              value={idOperation} />
          </Col>
          {persons.map((person, index) => {
            return (
              <Col key={index} xs={12} md={4} style={{ paddingLeft: 0, marginBottom: 10, paddingRight: '15px' }}>
                <EnquiryCard
                  person={person}
                  idQuestion={person.idQuestion}
                  field={person.dsQuestion}
                  value={person.answer} />
              </Col>)
          })}

        </EnquiryCardContainer>
      </Row>
      <Row sm={12} md={12}>
        {!isClient && (
          <NotesAccordion
            idQuestion={789}
            history={props.history}
            title="Anotações"
            idOperation={idOperation}
          />
        )}
      </Row>
    </Content>
  );
}
